import { Card as AntdCard } from 'antd';
import styled from 'styled-components';
import { Caption01, ProductiveHeading07 } from 'components/styles';

export const Card = styled(AntdCard).attrs({
  bordered: false,
})`
  .ant-card-head {
    min-height: 0;
    border-bottom: 0;
  }
`;

const CardHeadHeight = 42;

export const ResponsiveCard = styled(Card)`
  cursor: default;
  height: 100%;
  max-height: 386px;
  overflow: hidden;

  &::before {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  .ant-card-head-title {
    ${ProductiveHeading07};
    font-weight: normal;
    padding: var(--spacing-04) 0;

    a {
      font-weight: normal;
    }
  }

  .ant-card-head {
    height: ${CardHeadHeight}px;
    position: absolute;
    top: 0;
    width: 100%;
  }

  .ant-card-body {
    bottom: 0;
    left: 0;
    margin: var(--spacing-04) var(--spacing-02) var(--spacing-05) 0;
    overflow: hidden;
    overflow-y: auto;
    padding: 0 var(--spacing-04) 0 var(--spacing-05);
    position: absolute;
    right: 0;
    top: ${CardHeadHeight}px;
  }
`;

export const KEIResponsiveCard = styled(Card)`
  cursor: default;
  height: 386px;
  max-height: 772px;
  overflow: hidden;
  padding: 0;

  &::before {
    content: '';
    display: block;
    padding-bottom: 100%;
  }

  .ant-card-head-title {
    ${ProductiveHeading07};
    font-weight: normal;

    a {
      font-weight: normal;
    }
  }

  .ant-card-head {
    display: none;
  }

  .ant-card-body {
    bottom: 0;
    left: 0;
    overflow: auto;
    overflow-y: auto;
    padding: 0 var(--spacing-04) 0 var(--spacing-05);
    position: absolute;
    right: 0;
    top: 10px;
  }
`;

export const EmptyParagraph = styled.p`
  ${Caption01};
`;

export const DueBy = styled.span`
  color: var(--error-color);
  max-width: 32px;
`;
